import React from 'react';
import Page404 from 'pages/Page404';
import { FeatureId } from 'services/features/catalog';
import { useFeatureEnabled } from 'services/features/hooks';

const FeatureGate = ({
  children,
  feature,
}: {
  children: React.ReactNode;
  feature: FeatureId;
}) => {
  const { enabled, isLoading } = useFeatureEnabled(feature);

  if (isLoading) {
    return null;
  }

  if (!enabled) {
    return <Page404 />;
  }

  return children;
};

export default FeatureGate;
